/**
 * AI Badge Component
 * 
 * Visual indicator for AI-personalized products (Pack Leader only)
 * Presentation layer only - no business logic
 */

'use client'

import React from 'react'
import { Sparkles } from 'lucide-react'

interface AIBadgeProps {
  className?: string
  size?: 'sm' | 'md'
}

export function AIBadge({ className = '', size = 'sm' }: AIBadgeProps) {
  const iconSize = size === 'sm' ? 12 : 14
  
  return (
    <div
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 border border-purple-200 ${className}`}
    >
      <Sparkles 
        className="text-purple-600 flex-shrink-0" 
        style={{ width: iconSize, height: iconSize }} 
      />
      <span className={`${size === 'sm' ? 'text-[10px]' : 'text-xs'} font-semibold text-purple-700`}>
        AI
      </span>
    </div>
  )
}
